import AppLanguagePicker from '@map/components/AppLanguagePicker';
import GuestAreaAppBar from '@map/components/GuestArea/GuestAreaAppBar';
import { windowExtended } from '@map/types';
import { Typography } from '@mui/material';
import { makeStyles } from '@skill-survey/theme';
import AdaptiveImage from '@ui/AdaptiveImage';
import NavButton from '@ui/NavButton';
import { FormattedMessage } from 'react-intl';
import Container from '../Layout/Container';
import { guestLinks } from './links';

const useStyles = makeStyles('welcome')(({ spacing, breakpoints }) => ({
  rootContainer: {
    [breakpoints.down('sm')]: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing(4),
    textAlign: 'center',
    marginTop: spacing(10),
    [breakpoints.down('sm')]: {
      marginTop: spacing(0),
      justifyContent: 'center',
      flexGrow: 1,
    },
  },
  buttonContainer: {
    display: 'flex',
    gap: spacing(4),
  },
  alreadyHaveAccountContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing(4),
    justifySelf: 'flex-end',
    paddingBottom: spacing(10),
    [breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  signInButton: {
    [breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

const WelcomePage = () => {
  const { classes } = useStyles();
  return (
    <Container className={classes.rootContainer}>
      <GuestAreaAppBar>
        <AppLanguagePicker />
      </GuestAreaAppBar>
      <div className={classes.content}>
        <AdaptiveImage src={windowExtended.projectLogo} />
        <Typography variant="body2" color="textSecondary">
          <FormattedMessage id="skill_survey.welcome.welcome_text_description" />
        </Typography>
        <div className={classes.buttonContainer}>
          <NavButton size="medium" to={guestLinks.register}>
            <FormattedMessage id="skill_survey.welcome.get_started_title" />
          </NavButton>
          <NavButton
            className={classes.signInButton}
            size="medium"
            variant="secondary"
            to={guestLinks.authentication}
          >
            <FormattedMessage id="skill_survey.welcome.sign_in_cta" />
          </NavButton>
        </div>
      </div>
      <div className={classes.alreadyHaveAccountContainer}>
        <Typography variant="body2">
          <FormattedMessage id="skill_survey.welcome.already_have_an_account_title" />
        </Typography>
        <NavButton size="medium" variant="secondary" to={guestLinks.authentication}>
          <FormattedMessage id="skill_survey.welcome.sign_in_cta" />
        </NavButton>
      </div>
    </Container>
  );
};

export default WelcomePage;
